
































































import Vue from 'vue'
import HistoricalAlarm from '@/components/alarm-history/table.vue'
import FilterHistoricalAlarm from '@/components/alarm-history/filter.vue'
import _ from 'lodash'

import io from '@/socket.io/index'

import {
  FindAlarmHistory,
  AlarmHistory,
  AckAllAlarm,
  FilterAlarmHistory,
} from '@/api/alarm'

export default Vue.extend({
  name: 'HistoricalAlarmPanel',
  props: {
    value: Object,
  },
  components: {
    HistoricalAlarm,
    FilterHistoricalAlarm,
  },
  data() {
    return {
      currentPage: 1,
      totalRows: 0,
      fromNumber: 0,
      toNumber: 0,
      items: [] as AlarmHistory[],
      filter: {
        start: 0,
        end: 0,
        limit: 25,
        offset: 0,
        sort: 'created_at DESC',
      } as FilterAlarmHistory,
    }
  },
  methods: {
    async findAlarmHistory() {
      const { data, count, offset, limit } = await FindAlarmHistory(this.filter)
      this.items = data
      this.totalRows = count

      const mod = offset % limit
      this.currentPage = (offset - mod) / limit + 1
      this.fromNumber = count == 0 ? 0 : offset + 1
      this.toNumber = count == 0 ? 0 : this.fromNumber + data.length - 1
    },

    async ackAllAlarm() {
      await AckAllAlarm()
    },

    subscribeSocketNotification() {
      // const self = this
      io.on('alarm', this.findAlarmHistory)
    },

    unsubscribeSocketNotification() {
      // const self = this
      io.removeEventListener('alarm', this.findAlarmHistory)
    },
  },

  watch: {
    filter: {
      deep: true,
      handler: async function() {
        // eslint-disable-next-line
        ;(this as any).debounceFindAlarm()
      },
    },

    currentPage: async function(v: number) {
      this.filter.offset = (v - 1) * this.filter.limit
    },
  },

  async created() {
    if (this.value.attributes.snapshot) {
      return
    }

    // eslint-disable-next-line
    ;(this as any).debounceFindAlarm = _.debounce(this.findAlarmHistory, 500)

    await this.findAlarmHistory()
    this.subscribeSocketNotification()
  },
  beforeDestroy() {
    this.unsubscribeSocketNotification()
  },
})
